/**
    @title: Lazy Loading
    @observers: {
        - image: Images with srcset data attribute
        - iframe: Iframes with the iframe src data attribute
        - background: backgrounds with the bg data attribute
    }
**/

const awardMenuWrapper = document.querySelector("[data-award-container]");
const awardMenu 	   = document.querySelector("[data-award-menu]");

/**
    @title: Lazy
    @description: Uses Intersection Observer to check whether or not the item is within the viewport.
		If it is then we need to change the markup so the element is loaded.
**/
function initAwards() {

	// awards bio slider
	const awardTrigger = document.querySelectorAll("[data-award-open]");
	const awardClose   = document.querySelectorAll("[data-award-close]");

	if (awardMenu) {
		// Check the trigger exists
		if (awardTrigger) {
			
			awardTrigger.forEach(function (open) {
				open.addEventListener("click", menuButtonHandler.bind(open, "open"));
				console.log('award added: open');
			});
		}

		// Check the close button exists
		if (awardClose) {
			awardClose.forEach(function (close) {
				close.addEventListener("click", menuButtonHandler.bind(close, "close"));
				console.log('award added: close');
			});
		}
	}


	function menuButtonHandler(action) {
		switch (action) {
			case "open":
				awardMenuWrapper.setAttribute("data-award-container", "open");

				document.body.setAttribute("data-award-open", "");
				awardMenu.setAttribute("data-award", "open");
				awardMenu.setAttribute("aria-hidden", "false");

				// Get the award content
				var awardImage  = this.getAttribute("data-award-image");
				var awardTitle  = this.getAttribute("data-award-title");
				var awardText   = this.getAttribute("data-award-text");
				var awardLink   = this.getAttribute("data-award-link");

				var awardContentImage = document.querySelector("[data-award-content-image]");
				var awardContentTitle = document.querySelector("[data-award-content-title]");
				var awardContentText  = document.querySelector("[data-award-content-text]");
				var awardContentLink  = document.querySelector("[data-award-content-link]");

				// awardContentImage.innerHTML = '<img class="" style="width: 200px;" src="'+awardImage+'" />';
				awardContentTitle.innerHTML = awardTitle;
				awardContentText.innerHTML  = awardText;
				if (awardLink){
					awardContentLink.innerHTML  = '<a target="_blank" href="'+awardLink+'" class="text-white mt-4">Learn More</a>';
				}

				break;
			case "close":
				awardMenuWrapper.setAttribute("data-award-container", "closed");

				document.body.removeAttribute("data-award-open");
				awardMenu.setAttribute("data-award", "");
				awardMenu.setAttribute("aria-hidden", "true");
				break;
			default:
				return;
		}
	}

}

export { initAwards };
